import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { editCategory, fetchDetailCategory, loadingSet } from "../store/actions/categoryActions";
import Swal from "sweetalert2";
import LoadingComponent from "../components/LoadingComponent";

export default function EditCategoryPage() {
	const params = useParams();
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const { loading } = useSelector((state) => state.categories);
	const [editedCategory, setEditedCategory] = useState({
		name: "",
	});

	useEffect(() => {
		dispatch(fetchDetailCategory(params.categoryId))
			.then((category) => {
				setEditedCategory({
					name: category.name,
				});
			})
			.catch((err) => {
				Swal.fire({
					icon: "error",
					title: "Error",
					text: err,
				});
				navigate("/categories");
			})
			.finally(() => {
				dispatch(loadingSet(false));
			});
	}, []);

	const changeInputEditedCategory = (e) => {
		const { name, value } = e.target;
		setEditedCategory({
			...editedCategory,
			[name]: value,
		});
	};

	const submitHandler = (e) => {
		e.preventDefault();

		dispatch(editCategory(params.categoryId, editedCategory))
			.then(() => {
				Swal.fire({
					position: "top-end",
					icon: "success",
					title: "successfully edited category",
					showConfirmButton: false,
					timer: 1000,
				});
				navigate("/categories");
			})
			.catch((err) => {
				Swal.fire({
					icon: "error",
					title: "Error",
					text: err,
				});
			})
			.finally(() => {
				dispatch(loadingSet(false));
			});
	};
	return (
		<>
			{loading ? (
				<LoadingComponent />
			) : (
				<div className="container">
					<h2 className="mb-3">Edit Category</h2>
					<form onSubmit={submitHandler}>
						<div className="mb-3">
							<label className="form-label">Name</label>
							<input
								type="text"
								name="name"
								className="form-control"
								value={editedCategory.name}
								onChange={changeInputEditedCategory}
							/>
						</div>
						<div>
							<button type="submit" className="btn btn-primary">
								Save
							</button>
						</div>
					</form>
				</div>
			)}
		</>
	);
}
